<template>
  <div v-if="loading" class="p-12 text-center">
    <Loader />
  </div>
  <div v-else>
    <ViewHeader :project="project" :account-id="accountId" />
    <ViewNavigation :account-id="accountId" :project-id="projectId" />
    <div class="p-4 lg:p-12">
      <div class="max-w-7xl mx-auto">
        <router-view />
      </div>
    </div>

    <portal v-if="displayDeleteConfirmation" to="app-dialog">
      <BaseDialogDelete
        danger
        :custom-classes="'max-w-md'"
        @closed="displayDeleteConfirmation = false"
        @confirmed="doDelete"
      />
    </portal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import ViewHeader from './_projectId/components/ViewHeader.vue';
import ViewNavigation from './_projectId/components/ViewNavigation.vue';

export default {
  components: {
    ViewHeader,
    ViewNavigation,
  },

  props: {
    accountId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    loading: false,
    displayDeleteConfirmation: false,
  }),

  computed: {
    ...mapState('ui/projects', ['meta']),
    ...mapGetters('ui/projects', ['project']),
  },

  created() {
    this.initialize();
  },

  destroyed() {
    this.setCurrent(null);
  },

  methods: {
    ...mapActions('ui/projects', {
      readProject: 'read',
      deleteProject: 'destroy',
    }),

    ...mapMutations('ui/projects', ['setCurrent']),

    async initialize() {
      this.loading = true;
      const { projectId: projectUuid } = this;
      await this.readProject({
        projectUuid,
        params: { include: 'owner,product,cover' },
      });
      this.loading = false;
    },

    async doDelete() {
      this.loading = true;

      const { projectId: projectUuid } = this;

      try {
        await this.deleteProject({ projectUuid });

        this.goToProjectList();
      } catch (error) {
        // silence
      }

      this.loading = false;
    },

    goToProjectList() {
      this.$router.replace({
        name: 'accounts.projects',
        params: {
          accountId: this.accountId,
        },
      });
    },
  },
};
</script>
